var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"primary font-roboto",class:{ 'secondary': _vm.status === 'BREAK' },attrs:{"id":"app"}},[_c('Main',{staticClass:"bg-base-color text-light-color h-screen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }